import { render, staticRenderFns } from "./IndustryCard.vue?vue&type=template&id=269d6246&scoped=true&"
import script from "./IndustryCard.vue?vue&type=script&lang=js&"
export * from "./IndustryCard.vue?vue&type=script&lang=js&"
import style0 from "./IndustryCard.vue?vue&type=style&index=0&id=269d6246&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269d6246",
  null
  
)

export default component.exports